var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.1 137.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #223c6a;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 68.1,
    cy: 69.3,
    r: 65.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.7,41.9c-3.5-8.2-8.4-15.5-14.7-21.8-6.3-6.3-13.6-11.2-21.8-14.7C86.7,1.8,77.8,0,68.5,0s-18.2,1.8-26.7,5.4c-8.2,3.5-15.5,8.4-21.8,14.7-6.3,6.3-11.2,13.6-14.7,21.8C1.8,50.3,0,59.3,0,68.5s1.8,18.2,5.4,26.7c3.5,8.2,8.4,15.5,14.7,21.8s13.6,11.2,21.8,14.7c8.5,3.6,17.4,5.4,26.7,5.4s18.2-1.8,26.7-5.4c8.2-3.5,15.5-8.4,21.8-14.7,6.3-6.3,11.2-13.6,14.7-21.8,3.6-8.5,5.4-17.4,5.4-26.7s-1.8-18.2-5.4-26.7h-.1ZM68.5,132.7c-35.4,0-64.2-28.8-64.2-64.2S33.1,4.3,68.5,4.3s64.2,28.8,64.2,64.2-28.8,64.2-64.2,64.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.2,38.4l12,12c.5.5.5,1.4,0,2l-7,7-13.9-13.9,7-7c.5-.5,1.4-.5,2,0h0ZM91.3,61.3l-34.7,34.7c-.2.2-.5.3-.7.4-.7.2-8.1,2.2-8.1,2.2l-8.2,2.2c-.7.2-1.5-.2-1.7-1,0-.2,0-.5,0-.7l2.2-8.2h0c0,0,2.2-8.2,2.2-8.2,0-.2.2-.5.4-.6h0s34.7-34.7,34.7-34.7l13.9,13.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4590b6a2261a641cc646b1b60dd580f8.svg";
export { ForwardRef as ReactComponent };